import React from 'react';

const ShippingBus = ({ color = '#424242' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9827 1.66602V9.99935C12.9827 10.916 12.2327 11.666 11.3161 11.666H2.14941V4.99935C2.14941 3.15768 3.64108 1.66602 5.48275 1.66602H12.9827Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8161 11.666V14.166C18.8161 15.5493 17.6994 16.666 16.3161 16.666H15.4827C15.4827 15.7493 14.7327 14.9993 13.8161 14.9993C12.8994 14.9993 12.1494 15.7493 12.1494 16.666H8.81608C8.81608 15.7493 8.06608 14.9993 7.14941 14.9993C6.23275 14.9993 5.48275 15.7493 5.48275 16.666H4.64941C3.26608 16.666 2.14941 15.5493 2.14941 14.166V11.666H11.3161C12.2327 11.666 12.9827 10.916 12.9827 9.99935V4.16602H14.5161C15.1161 4.16602 15.6661 4.49102 15.9661 5.00769L17.3911 7.49935H16.3161C15.8577 7.49935 15.4827 7.87435 15.4827 8.33268V10.8327C15.4827 11.291 15.8577 11.666 16.3161 11.666H18.8161Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.14909 18.3333C8.06956 18.3333 8.81576 17.5871 8.81576 16.6667C8.81576 15.7462 8.06956 15 7.14909 15C6.22861 15 5.48242 15.7462 5.48242 16.6667C5.48242 17.5871 6.22861 18.3333 7.14909 18.3333Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8161 18.3333C14.7366 18.3333 15.4827 17.5871 15.4827 16.6667C15.4827 15.7462 14.7366 15 13.8161 15C12.8956 15 12.1494 15.7462 12.1494 16.6667C12.1494 17.5871 12.8956 18.3333 13.8161 18.3333Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8158 10V11.6667H16.3158C15.8574 11.6667 15.4824 11.2917 15.4824 10.8333V8.33333C15.4824 7.875 15.8574 7.5 16.3158 7.5H17.3908L18.8158 10Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default React.forwardRef(ShippingBus);
